<template>
	<transition name="cookie" :duration="450" appear>
		<dialog v-if="cookieShown" :open="cookieShown" class="cookie-toast-wrapper">
			<div class="cookie-toast">

				<div class="cookie-toast__body">
					<span class="cookie-toast__text">
						Для повышения удобства пользования Сайтом мы используем файлы Cookie.<br> Оставаясь на Сайте, Вы соглашаетесь с их использованием и <a class="l cookie-toast__link" target="_blank" :href="privacyPolicyUrl">Политикой конфиденциальности</a>.
					</span>
					<button type="button" class="cookie-toast__btn btn" @click="closeCookie">
						<span class="btn__text">Принять</span>
					</button>
				</div>
			</div>
		</dialog>
	</transition>
</template>

<script>
const STORAGE_KEY = 'showCookiePush';
const SHOW_DELAY_MS = 3000;

export default {
	name: 'CookieInfo',
	data() {
		return {
			cookieShown: false,
			privacyPolicyUrl: '/upload/Политикa-конфиденциальности.pdf',
			showTimerId: null,
		};
	},
	mounted() {
		if (localStorage.getItem(STORAGE_KEY)) {
			return;
		}

		this.showTimerId = window.setTimeout(() => {
			this.cookieShown = true;
		}, SHOW_DELAY_MS);
	},
	methods: {
		closeCookie() {
			this.cookieShown = false;
			localStorage.setItem(STORAGE_KEY, false);
		},
	},
};
</script>

<style scoped>
.cookie-toast-wrapper {
	position: fixed;
	right: 0;
	bottom: 20px;
	left: 0;
	z-index: 1000;
	display: flex;
	justify-content: center;
	padding: 0 16px;
	border: none;
	background: none;
	pointer-events: none;
	width: 100%;
	max-width: 900px;
}

.cookie-toast {
	position: relative;
	padding: 14px;
	border: none;
	border-radius: 16px;
	background-color: #00000082;
	pointer-events: all;
}

.cookie-toast__body {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 20px;
	color: #fff;
}

.cookie-toast__link {
	color: #fff;
	text-decoration: underline;
}
.cookie-enter-active,
.cookie-leave-active {
	transition: opacity 0.3s ease, transform 0.3s ease;
}

.cookie-enter-from,
.cookie-leave-to {
	opacity: 0;
	transform: translateY(8px);
}
</style>
